import { createFileRoute } from "@tanstack/react-router";
import ThankYouSaintEs from "@/pages/es/ThankYouSaintEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/thank-you-saint`;

export const Route = createFileRoute("/es/thank-you-saint")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      {
        title: "Gracias — SAINT® Consulta Gratuita | Neuro Wellness TMS",
      },
      {
        name: "description",
        content:
          "Gracias por su interés en SAINT® TMS. Nuestro equipo en Coral Springs, FL se comunicará con usted sobre su tratamiento de depresión de 5 días.",
      },
      {
        property: "og:title",
        content: "Reserve su consulta gratuita de SAINT®",
      },
      {
        property: "og:description",
        content:
          "Próximo paso: reserve su consulta gratuita de SAINT® con Neuro Wellness TMS Centers of America.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Reserve su consulta gratuita de SAINT®",
      },
      {
        name: "twitter:description",
        content:
          "Próximo paso: reserve su consulta gratuita de SAINT® con Neuro Wellness TMS Centers of America.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/thank-you-saint"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <ThankYouSaintEs />;
}
